import { FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { SetupWizardCsvFieldSpec, SetupWizardCsvFieldType } from '@mira-avant/mtlibs';

export class FormUtil {
	static applyCsvSpecValidators(form: FormGroup, csvSpec: SetupWizardCsvFieldSpec[]): void {
		for (const spec of csvSpec) {
			const control = form.get(spec.field);

			if (!control) {
				continue;
			}

			const validators: ValidatorFn[] = [];

			if (spec.required) {
				validators.push(Validators.required);
			}

			switch (spec.type) {
				case SetupWizardCsvFieldType.TEXT:
					validators.push(
						Validators.minLength(2),
						// Trim whitespace validator
						Validators.pattern(/^\S.*\S$|^$/) // no leading/trailing spaces (except empty)
					);
					break;

				case SetupWizardCsvFieldType.NUMBER:
					validators.push(
						Validators.pattern(/^-?(?:\d+|\d*\.\d+)$/)
						// If you later add minValue / maxValue to spec, add here:
						// spec.minValue !== undefined && Validators.min(spec.minValue),
						// spec.maxValue !== undefined && Validators.max(spec.maxValue),
					);
					break;

				case SetupWizardCsvFieldType.DATE:
					// Very basic ISO or MM/DD/YYYY validation
					validators.push(Validators.pattern(/^(\d{4}-\d{2}-\d{2}|\d{1,2}\/\d{1,2}\/\d{2,4})$/));
					// Better: use a custom validator that checks Date.parse()
					break;

				case SetupWizardCsvFieldType.BOOLEAN:
					validators.push(Validators.pattern(/^(true|false)$/i));
					break;
			}

			control.setValidators(validators.length ? validators : null);
			control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
		}
	}
}
